// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qp-9";
export var arrowButtonContainer = "_qp-5";
export var arrowButtonIcon = "_qp-6";
export var carouselArrowButton = "_qp-2";
export var carouselElementContainer = "_qp-1";
export var currentSlide = "_qp-8";
export var left = "_qp-3";
export var otherSlide = "_qp-a";
export var productCarouselContainer = "_qp-0";
export var right = "_qp-4";
export var sliderOverflow = "_qp-7";